import type { MetodoPago } from './estados';

/** Servicios de una cita en una línea: «Corte + Barba», o en corto «Corte +1». */
export function nombreServicios(servicios: { nombre: string }[], corto = false): string {
  const [primero, ...resto] = servicios;
  if (!primero) return '';
  if (resto.length === 0) return primero.nombre;
  return corto ? `${primero.nombre} +${resto.length}` : servicios.map((s) => s.nombre).join(' + ');
}

const NOMBRE_METODO: Record<MetodoPago, { solo: string; junto: string }> = {
  efectivo: { solo: 'Efectivo', junto: 'Efectivo' },
  transferencia: { solo: 'Transferencia', junto: 'Transf.' },
  tarjeta: { solo: 'Tarjeta', junto: 'Tarjeta' },
};

/** Etiqueta del método de pago de una venta; con varios métodos la forma corta es «Mixto». */
export function etiquetaMetodosPago(metodos: MetodoPago[]): { larga: string; corta: string } {
  const unicos = [...new Set(metodos)];
  if (unicos.length === 0) return { larga: '', corta: '' };
  if (unicos.length === 1) {
    const solo = NOMBRE_METODO[unicos[0]!].solo;
    return { larga: solo, corta: solo };
  }
  return { larga: unicos.map((m) => NOMBRE_METODO[m].junto).join(' + '), corta: 'Mixto' };
}

type ServicioCita = { id: string; nombre: string; precio: number };

/**
 * Servicios de una cita vista. Una cita guardada en la caché del navegador antes de esta versión no trae
 * `servicios`: se usa su servicio principal.
 */
export function serviciosDe(c: { servicio: ServicioCita; servicios?: ServicioCita[] }): ServicioCita[] {
  return c.servicios?.length ? c.servicios : [c.servicio];
}
